import { render, staticRenderFns } from "./brookfieldHomes.vue?vue&type=template&id=602d4e8a&"
import script from "./brookfieldHomes.vue?vue&type=script&lang=js&"
export * from "./brookfieldHomes.vue?vue&type=script&lang=js&"
import style0 from "./brookfieldHomes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports